module.exports = __webpack_public_path__ + "img/plate01_06.6e2d3bf0.png";